import React from "react";
import classNames from "classnames";

import classes from "../style.module.scss";

export const TableHeader = ({ children, gridTemplateColumns = "" }) => {
    return (
        <li className={`${classes.item} ${classes.head}`} style={{ gridTemplateColumns: gridTemplateColumns }}>
            {children}
        </li>
    );
};

export const TableRow = ({ children, id, disabled, gridTemplateColumns = "" }) => {
    return (
        <li
            className={classNames(classes.item, { [classes.disabled]: disabled })}
            id={id}
            style={{ gridTemplateColumns: gridTemplateColumns }}
        >
            {children}
        </li>
    );
};

export const Section = ({ title, subtitle, children, className, bodyClassName }) => {
    return (
        <div className={classNames(classes.section, className)}>
            <h3 className={classes.title}> {title} </h3>
            <div className={bodyClassName}>{children}</div>
            {subtitle && <p className={classes.subtitle}> {subtitle} </p>}
        </div>
    );
};

/** @deprecated Layout moved to ConfigurationRunDock + ReadinessChecklist */
const SimulationInfo = () => null;

export default SimulationInfo;
